<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">

          <el-form-item label="时间">
            <template slot="label">
              时间
            </template>
            <el-date-picker v-model="queryDate" type="daterange" @change="dateChange" value-format="yyyy-MM-dd"
              range-separator="-" :start-placeholder="$t('public22')" :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="resetQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
        </el-form>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column  label="主题" prop="title">
            <template slot="header">
              <I18Lang id="public83" defaultText="主题" />
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="create_time">
            <template slot="header">
              <I18Lang id="public84" defaultText="时间" />
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="name">
            <template slot="header">
              <I18Lang id="my96" defaultText="操作" />
            </template>
            <template slot-scope="scope">
              <div class="operat-group">
                <span class="operat-item btn-query" @click="lookInfo(scope.row)"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="消息" :visible.sync="dialog.preview" width="50%"
      :close-on-click-modal="false" :close-on-press-escape="false" class="info-dialog">

      <div class="msg">
        <div class="title">
          {{ currentData.title }}
        </div>
        <div class="content" v-html="currentData.content">
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <div class="btn kg-btn2" @click="dialog.preview = false">
          <I18Lang id="my98" defaultText="关闭" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
import { auditStatusList } from '@utils/global'
export default {
  name: 'record',
  data () {
    return {
      fileDomain,
      dialog: {
        preview: false
      },
      queryDate: '',
      queryForm: {
        start_time: '',
        end_time: '',
        auth_status: '',
        page: '',
        size: ''
      },
      statusList: auditStatusList,
      currentData: {},
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'currMarket'])
  },
  created () {
    this.getRecord()
  },
  methods: {
    getRecord () {
      this.$http.post('/api/user/noticeMessageList', this.queryForm).then(result => {
        console.log('result', result)
        this.tableData = result
      })
    },
    resetQuery () {
      this.queryForm.page = 1
      this.getRecord()
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    lookInfo (item) { // 查看凭证
      this.currentData = item
      this.dialog.preview = true
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .info-dialog {
  .el-dialog {
    width: 606px !important;
    min-height: 420px;
    background: url("../../../assets/img/user/short-bg.png") no-repeat center /
      100% 100%;
  }
}
.msg{
  padding: 20px;
  .title{
    color: #fff;
    text-align: center;
    margin-bottom: 50px;
    font-size: 16px;
  }
  .content{
    color: #fff;
    font-size: 16px;
  }
}</style>
